import { render } from "./LoginRootCaptchaTest.vue?vue&type=template&id=5fc9111e"
import script from "./LoginRootCaptchaTest.vue?vue&type=script&lang=js"
export * from "./LoginRootCaptchaTest.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__